import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Container,
  Box,
  Typography,
  Paper,
  Button,
  Snackbar,
  Alert,
  Grid,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton
} from "@mui/material";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
import { investorApi } from "../../api/api";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const UpdateKyc = () => {
  const location = useLocation();
  const { InvestorName, mobileNumber, pancardNumber, pancardURL, Status, adhaarNumber, AdhaarURL } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [formState, setFormState] = useState({ selectedOption: "" });
  const [documentUrl, setDocumentUrl] = useState("");
  const [openModal, setOpenModal] = useState(false);

  const handleDropdownChange = (event) => {
    setFormState({ ...formState, selectedOption: event.target.value });
  };

  const handleOpenModal = (url) => {
    setDocumentUrl(url);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setDocumentUrl("");
  };
  const openPdf = (url) => {
    window.open(url, "_blank");
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = documentUrl;
    link.download = "document.pdf"; 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const saveInvestDetails = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await investorApi.updateKyc({
        id: location.state.id,
        status: formState.selectedOption,
      });

      if (response.status === 200) {
        setSnackbarMessage("KYC status updated successfully!");
        setSnackbarSeverity("success");
      } else {
        setSnackbarMessage("Failed to update KYC status.");
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error("Error updating KYC:", error);
      setSnackbarMessage("An error occurred while updating KYC.");
      setSnackbarSeverity("error");
    }

    setSnackbarOpen(true);
    setLoading(false);
  };

  return (
    <Container sx={{ py: 5, maxWidth: "80%" }}>
      <Backdrop open={loading} sx={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
        <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: "100%" }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>
        <Typography variant="h4" component="h1" sx={{ color: "#13216e", fontWeight: 600, fontSize: "24px" }}>
         Kyc Details
        </Typography>
        <Box>
          <Link to="/property" style={{ textDecoration: "none", color: "#4e0dff", fontSize: "18px" }}>Home</Link>
          <BsArrowRight style={{ margin: "-2px 8px", color: "#4e0dff" }} />
          <Link to="#" style={{ textDecoration: "none", color: "#4e0dff", fontSize: "18px" }}>KYC</Link>
        </Box>
      </Box>

      <Paper elevation={3} sx={{ p: 4 }}>
        <form onSubmit={saveInvestDetails}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="body1" sx={{ color: "#13216e", fontWeight: 600, fontSize: "24px" }}><strong>{InvestorName},</strong></Typography>
              <Typography variant="body1" sx={{ color: "#13216e", fontWeight: 600, fontSize: "18px" }}><strong>{mobileNumber}.</strong></Typography>
              <Typography variant="body1" sx={{color:"#13216e",fontWeight:600,fontSize:"18px"}}><strong>{Status}</strong></Typography>
            </Grid>

            {/* Aadhar Details (Number + Document in the same row) */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6" sx={{ color: "blue" }}>Aadhar Number: {adhaarNumber}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 1,
                mb: 1,
                borderRadius: 1,
                backgroundColor: "#f5f5f5",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PictureAsPdfIcon color="error" />
                <Typography>View Adhaar Document</Typography>
              </Box>
              <Box>
                <IconButton onClick={() => openPdf(AdhaarURL)} aria-label="view" size="small">
                  <OpenInNewIcon />
                </IconButton>
              </Box>
            </Box>
            </Grid>

            {/* PAN Details (Number + Document in the same row) */}
            <Grid item xs={12} md={6}>
              <Typography variant="h6" sx={{ color: "blue" }}>PAN Number: {pancardNumber}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 1,
                mb: 1,
                borderRadius: 1,
                backgroundColor: "#f5f5f5",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PictureAsPdfIcon color="error" />
                <Typography>View Adhaar Document</Typography>
              </Box>
              <Box>
                <IconButton onClick={() => openPdf(pancardURL)} aria-label="view" size="small">
                  <OpenInNewIcon />
                </IconButton>
              </Box>
            </Box>
            </Grid>

            {/* KYC Status Selection */}
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel>Select Status</InputLabel>
                <Select value={formState.selectedOption} onChange={handleDropdownChange}>
                  <MenuItem value="Initiated">Initiated</MenuItem>
                  <MenuItem value="Rejected">Rejected</MenuItem>
                  <MenuItem value="Completed">Completed</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
            <Button variant="outlined" color="secondary" sx={{ mr: 2 }}>Reset</Button>
            <Button type="submit" variant="contained" color="primary">Save Changes</Button>
          </Box>
        </form>
      </Paper>

      {/* Modal for document preview with download button */}
      <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth>
        <DialogTitle>Document Preview</DialogTitle>
        <DialogContent>
          <iframe src={documentUrl} width="100%" height="500px" title="Document Preview"></iframe>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDownload} color="primary">Download</Button>
          <Button onClick={handleCloseModal} color="secondary">Close</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default UpdateKyc;
